import * as React from 'react'
import Skeleton from 'ui/src/components/Skeleton'

const Loading = () => <Skeleton className='w-full h-[338px]' />

export default Loading
